module.exports = __webpack_public_path__ + "img/003-mercury.698fbeb3.svg";